/**
 * [Feature registry] Frontend mirror of the backend feature registry
 * (flowdesk-api/src/config/feature-registry.js). The only cross-repo contract
 * is the set of string keys stored in the tenant `features` blob — exactly as
 * before this existed.
 *
 *   - `gate: 'shipped'`     → off-by-default; parses to an explicit `false`
 *                             when absent, so `hasFeature` hides the surface.
 *   - `gate: 'plan_gated'`  → fail-open; an absent key is enabled.
 *   - `planCard`            → renders as a checkbox on the Plans editor.
 *
 * Order is chosen so `planCardFeatures()` reproduces the pre-registry
 * FEATURE_CATALOGUE order exactly (see feature-registry.test.js).
 */
export const FEATURE_REGISTRY = [
  { key: 'sops', gate: 'plan_gated', planCard: true, label: 'SOPs + AI breakdown' },
  { key: 'workflows', gate: 'plan_gated', planCard: true, label: 'Workflows' },
  { key: 'gamification', gate: 'plan_gated', planCard: true, label: 'Gamification & Leaderboard' },
  { key: 'ai_usage', gate: 'plan_gated', planCard: true, label: 'AI Usage' },
  { key: 'api_access', gate: 'plan_gated', planCard: true, label: 'Bring Your Own AI keys' },
  { key: 'weekly_goals', gate: 'plan_gated', planCard: true, label: 'Weekly Goals & AI Analysis' },
  { key: 'external_collaboration', gate: 'shipped', planCard: true, label: 'External Collaborators' },
  { key: 'sop_integration', gate: 'shipped', planCard: false, label: 'SOP integration' },
]

/** Plans-editor checkbox rows, in display order (planCard entries only). */
export const planCardFeatures = () =>
  FEATURE_REGISTRY.filter((f) => f.planCard).map((f) => ({ key: f.key, label: f.label }))
